var React = require('react');

function CheckCircle (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"9","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"square","key":0}),React.createElement("path",{"d":"M8 13.2L10.4 15.6L16 10","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"square","key":1})]);
}

CheckCircle.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CheckCircle;

CheckCircle.default = CheckCircle;
